export * from '@stickyroll/context';
export { ScrollConsumer as Listener } from '@stickyroll/context';
import { Frame } from '@stickyroll/frame';
export * from '@stickyroll/frame';

class Stickyroll extends Frame {
}

export { Stickyroll };
